var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaiBanWeihui(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "currentColor",
    rx: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.42 16.84c-.77 0-1.4-.63-1.4-1.4V11.4c0-.77.63-1.4 1.4-1.4s1.4.63 1.4 1.4v4.04c0 .77-.62 1.4-1.4 1.4m12.4 0c.77 0 1.4-.63 1.4-1.4V11.4c0-.77-.63-1.4-1.4-1.4s-1.4.63-1.4 1.4v4.04c.01.77.63 1.4 1.4 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 19.1v-2.93c0-2.29 1.86-4.15 4.15-4.15h1.28v3.4c0 1.1.9 2 2 2s2-.9 2-2v-3.4h8.4v3.4c0 1.1.9 2 2 2s2-.9 2-2v-3.4h.94c2.29 0 4.15 1.86 4.15 4.15v2.93zm0 2.79V33.8c0 2.29 1.86 4.15 4.15 4.15h18.62c2.29 0 4.15-1.86 4.15-4.15V21.89zm7.62 10.21h-1.38c-.77 0-1.4-.63-1.4-1.4s.63-1.4 1.4-1.4h1.38c.77 0 1.4.63 1.4 1.4s-.63 1.4-1.4 1.4m0-4.82h-1.38c-.77 0-1.4-.63-1.4-1.4s.63-1.4 1.4-1.4h1.38c.77 0 1.4.63 1.4 1.4s-.63 1.4-1.4 1.4m6.53 4.82h-1.39c-.77 0-1.4-.63-1.4-1.4s.63-1.4 1.4-1.4h1.38c.77 0 1.4.63 1.4 1.4s-.62 1.4-1.39 1.4m0-4.82h-1.39c-.77 0-1.4-.63-1.4-1.4s.63-1.4 1.4-1.4h1.38c.77 0 1.4.63 1.4 1.4s-.62 1.4-1.39 1.4m6.36 0h-1.38c-.77 0-1.4-.63-1.4-1.4s.63-1.4 1.4-1.4h1.38c.77 0 1.4.63 1.4 1.4s-.62 1.4-1.4 1.4"
  }))));
}
export default SvgPaiBanWeihui;